import React from 'react';
import ReactDOM from 'react-dom/client';
import './assets/styles/APP.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
// import * as serviceWorkerRegistration from './serviceWorkerRegistration'; 
import { AuthProvider } from "./context/AuthContext.js";
import { BrowserRouter as Router } from "react-router-dom";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <QueryClientProvider client={queryClient}>
    <Router>
      <AuthProvider>
        <React.StrictMode>
          <App />
        </React.StrictMode>
      </AuthProvider>
    </Router>
  </QueryClientProvider>
);

// تفعيل الـ Service Worker عشان التطبيق يقدر يتثبت
// serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// import React from 'react';
// import ReactDOM from 'react-dom/client';
// // import './index.css';
// import './assets/styles/APP.css';
// import App from './App';
// import reportWebVitals from './reportWebVitals';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import * as serviceWorkerRegistration from './serviceWorkerRegistration'; 
// import { AuthProvider } from "./context/AuthContext.js";
// import {BrowserRouter as Router} from "react-router-dom";
// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <Router>
//     <AuthProvider>
//       <React.StrictMode>
//         <App />
//       </React.StrictMode>
//     </AuthProvider>
//   </Router>
// );

// // تفعيل الـ Service Worker عشان التطبيق يقدر يتثبت
// serviceWorkerRegistration.register();

// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
